// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeProfileSearchByUsernameBody = {
  username: string;
};

export type typeProfileSearchByUsernameOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      userId: string;
      username: string;
      displayName: string;
      avatarUrl?: string | null;
    }[];
    nextCursor?: string | null;
  };
};

export type typeProfileSearchByUsernameOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileSearchByUsernameOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileSearchByUsernameOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaProfileSearchByUsernameBody = {
  type: "object",
  properties: { username: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["username"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createProfileSearchByUsername(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaProfileSearchByUsernameBody);
  }

  return async function postProfileSearchByUsername(
    payload: typeProfileSearchByUsernameBody,
  ): Promise<
    typeProfileSearchByUsernameOutput200 | typeProfileSearchByUsernameOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postProfileSearchByUsername" failed before calling the network. #70b697d42963`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#70b697d42963" },
        },
        data: null,
      } as typeProfileSearchByUsernameOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/profile/search-by-username`,
      httpMethod: "POST",
      options,
    })) as
      | typeProfileSearchByUsernameOutput200
      | typeProfileSearchByUsernameOutput400;
  };
}
